import { Moment } from 'moment';
import { _noop } from 'utils/function.utils';
import { PopupLayout } from './popup.store';
import { ButtonMetadata } from '../buttons/button-types';

export class PopupData {
  heading?: string;
  subHeading?: string;
  hasCancelButton!: boolean;
  hideCloseIcon?: boolean;
  allowBackgroundClose?: boolean;
  actionButton?: ButtonMetadata;
  onAction?: (e?: any) => void;
  onClose?: (e?: any) => void;
  content?: string;
  toDate?: Moment;
  fromDate?: Moment;
  selectedImage?: string;
  template!: PopupLayout;
}

export class PopupConfig extends PopupData {
  constructor(popupData: PopupData) {
    super();
    this.onAction = popupData.onAction === undefined ? _noop : popupData.onAction;
    this.onClose = popupData.onClose === undefined ? _noop : popupData.onClose;
    this.heading = popupData.heading;
    this.subHeading = popupData.subHeading;
    this.hasCancelButton = popupData.hasCancelButton;
    this.allowBackgroundClose = popupData.allowBackgroundClose;
    this.actionButton = popupData.actionButton;
    this.content = popupData.content;
    this.toDate = popupData.toDate;
    this.fromDate = popupData.fromDate;
    this.selectedImage = popupData.selectedImage;
    this.template = popupData.template;
    this.hideCloseIcon = popupData.hideCloseIcon;
  }
}